const WIDTH_SP = 768;

(() => {

  // 初期化処理
  const init = () => {
    const body = document.querySelector('body');
    body.style.opacity = "1";
    body.classList.remove('preload');

    // 各初期化関数の呼び出し
    initSmoothScroll();
    initIsOn();
    doFade();
    initSlider();
    initFaq();
    initFixedCta();
    initSceneView();
  };

  // リサイズイベント処理
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initTextStroke();
    }, 200);
  };

  // スクロールイベント処理
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      initIsOn();
      lastScrollTime = now;
    }
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll);
  
})();


// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const targetId = trigger.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId);
      if (targetElement) adjustScrollPosition(targetElement, 'smooth');
    });
  });
};

const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const gap = document.getElementById('header')?.clientHeight || 0 + 80;
  const target = rect + offset - gap;

  window.scrollTo({ top: target, behavior });
};

// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    }
  });
};

// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// スライダーのセット
const initSlider = () => {

  // 製品-製品サムネイル
  const prodThumbnail = new Swiper('.prod-thumbnail', {
    slidesPerView: 4,
    spaceBetween: "0.5%",
    freeMode: true,
    allowTouchMove: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      prevEl: '.prod-thumbnail-prev',
      nextEl: '.prod-thumbnail-next',
    },
  });
  const prodSwiper = new Swiper('.prod-slider', {
    navigation: {
      nextEl: '.prod-next',
      prevEl: '.prod-prev',
    },
    thumbs: {
      swiper: prodThumbnail
    }
  });

  // review
  //setReviewModalSlides();

  // User Voice
  const updateVoiceCounter = (swiper) => {
    const isPC = window.innerWidth >= 751;
    const total = isPC
      ? Math.ceil(swiper.slides.length / 1)
      : swiper.slides.length;

    const current = isPC
      ? Math.floor(swiper.activeIndex / 1) + 1
      : swiper.activeIndex + 1;

    document.getElementById("voiceSwiperIndex").textContent = current;
    document.getElementById("voiceSwiperTotal").textContent = total;
  };

  const voiceSwiper = new Swiper(".voice-slide", {
    slidesPerView: 1,
    spaceBetween: 8,
    navigation: {
      nextEl: ".voice-next",
      prevEl: ".voice-prev",
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true
    },
    on: {
      init: function () {
        updateVoiceCounter(this);
      },
      slideChange: function () {
        updateVoiceCounter(this);
      },
    },
    breakpoints: {
      751: {
        spaceBetween: 56,
      }
    }
  });

  // CTA1
  const ctaThumbnail1 = new Swiper("#cta-slider1-thumb", {
    slidesPerView: 7,
    freeMode: true,
    watchSlidesProgress: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true
    },
  });
  const cta1 = new Swiper("#cta-slider1", {
    slidesPerView: 1,
    loop: true,
    speed: 300,
    effect: "fade",
    thumbs: {
      swiper: ctaThumbnail1,
    },
  });

  // CTA2
  const ctaThumbnail2 = new Swiper("#cta-slider2-thumb", {
    slidesPerView: 7,
    freeMode: true,
    watchSlidesProgress: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true
    },
  });
  const cta2 = new Swiper("#cta-slider2", {
    slidesPerView: 1,
    loop: true,
    speed: 300,
    effect: "fade",
    thumbs: {
      swiper: ctaThumbnail2,
    },
  });

  // material 
  const updateMaterialCounter = (swiper) => {
    const isPC = window.innerWidth >= 751;
    const total = isPC
      ? Math.ceil(swiper.slides.length / 1)
      : swiper.slides.length;

    const current = isPC
      ? Math.floor(swiper.activeIndex / 1) + 1
      : swiper.activeIndex + 1;

    document.getElementById("materialSwiperIndex").textContent = current;
    document.getElementById("materialSwiperTotal").textContent = total;
  };
  const material = new Swiper("#material-slider", {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: false,
    speed: 300,
    navigation: {
      nextEl: ".material-next",
      prevEl: ".material-prev",
    },
    on: {
      init: function () {
        updateMaterialCounter(this);
      },
      slideChange: function () {
        updateMaterialCounter(this);
      },
    },
    breakpoints: {
      751: {
        spaceBetween: 40,
      }
    }
  });

  // howto
  const updateHowtoCounter = (swiper) => {
    const isPC = window.innerWidth >= 751;
    const total = isPC
      ? Math.ceil(swiper.slides.length / 1)
      : swiper.slides.length;

    const current = isPC
      ? Math.floor(swiper.activeIndex / 1) + 1
      : swiper.activeIndex + 1;

    document.getElementById("howtoSwiperIndex").textContent = current;
    document.getElementById("howtoSwiperTotal").textContent = total;
  };
  const howto = new Swiper("#howto-slider", {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: false,
    speed: 300,
    navigation: {
      nextEl: ".howto-next",
      prevEl: ".howto-prev",
    },
    on: {
      init: function () {
        updateHowtoCounter(this);
      },
      slideChange: function () {
        updateHowtoCounter(this);
      },
    },
    breakpoints: {
      751: {
        spaceBetween: 40,
      }
    }
  });

};

// モーダルの表示
function setReviewModal(index = 0) {
  const modal = document.querySelector(".review-modal");
  modal.style.display = "flex";

  // モーダル内のswiperを指定インデックスに移動（あれば）
  if (window.reviewSwiper) {
    window.reviewSwiper.slideTo(index);
  }
}

// モーダルを閉じる
function closeReviewModal() {
  const modal = document.querySelector(".review-modal");
  modal.style.display = "none";
}

// FAQ開閉 -------
const initFaq = () => {

  const moreBtn = Array.from(document.querySelectorAll('.faq-item-q'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;

      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });
}

// Fixed CTA の表示切り替え
const initFixedCta = () => {
  const fixedCta = document.getElementById("fixed-cta");
  const ctaElements = document.querySelectorAll(".cta, .product");

  if (!fixedCta || !ctaElements.length) return;

  const toggleFixedCta = () => {
    const viewportHeight = window.innerHeight;
    
    // cta または product 要素が画面上に表示されているかチェック
    let isElementVisible = false;
    ctaElements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      // 要素が画面上に表示されているか（上部が画面上部より下にあるか）
      if (rect.top > 0 && rect.top < viewportHeight) {
        isElementVisible = true;
      }
    });

    if (isElementVisible) {
      fixedCta.classList.remove("show");
    } else {
      fixedCta.classList.add("show");
    }
  };

  // スクロールイベントを直接 window に追加
  document.addEventListener("scroll", toggleFixedCta, { passive: true });
  window.addEventListener("scroll", toggleFixedCta, { passive: true });
  toggleFixedCta(); // 初期化時にも呼び出す
};

// シーンビューの制御
const initSceneView = () => {
  const sceneView = document.querySelector('.scene-view');
  const sceneViewInner = document.querySelector('.scene-view-inner');
  const sceneItems = document.querySelectorAll('.scene-view__item');
  const sceneItemsInner = document.querySelectorAll('.scene-view__item-inner');
  const sceneViewFixed = document.querySelector('.scene-view-fixed');

  if (!sceneView || !sceneViewInner || !sceneItems.length || !sceneViewFixed) return;

  // 最も高いアイテムの高さを取得して設定
  const setFixedHeight = () => {
    let maxHeight = 0;
    sceneItemsInner.forEach(item => {
      const height = item.offsetHeight;
      maxHeight = Math.max(maxHeight, height);
    });
    sceneViewFixed.style.height = `${maxHeight}px`;
  };

  const updateSceneView = () => {
    const sceneViewRect = sceneView.getBoundingClientRect();
    const sceneViewTop = sceneViewRect.top;
    const sceneViewHeight = sceneViewRect.height;
    const windowHeight = window.innerHeight;
    
    // シーンビューが画面上部に来たら処理開始
    if (sceneViewTop <= 0) {
      // シーンビューの表示範囲を計算
      const visibleHeight = Math.min(windowHeight, sceneViewHeight + sceneViewTop);
      const scrollProgress = Math.abs(sceneViewTop);
      
      // 各アイテムの表示タイミングを計算（要素数+1で分割）
      const itemHeight = sceneViewHeight / (sceneItems.length + 1);
      const currentIndex = Math.min(
        Math.floor(scrollProgress / itemHeight),
        sceneItems.length
      );

      // 各アイテムの表示制御
      sceneItems.forEach((item, index) => {
        if (index === currentIndex) {
          // 現在のインデックスのアイテムを表示
          item.classList.add('show');
        } else if (index === sceneItems.length - 1 && currentIndex === sceneItems.length) {
          // 最後の切り替えポイントでのみ、最後のアイテムを表示したままにする
          item.classList.add('show');
        } else {
          // その他のアイテムは非表示
          item.classList.remove('show');
        }
      });
    } else {
      // シーンビューが画面上部より上にある場合は最初のアイテムのみ表示
      sceneItems.forEach((item, index) => {
        if (index === 0) {
          item.classList.add('show');
        } else {
          item.classList.remove('show');
        }
      });
    }
  };

  // リサイズ時にも高さを再計算
  window.addEventListener('resize', setFixedHeight, { passive: true });
  window.addEventListener('scroll', updateSceneView, { passive: true });
  
  // 初期化
  setFixedHeight();
  updateSceneView();
};
